"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayDockCreditCardForm = void 0;
const React = require("react");
const widget_1 = require("@paydock/client-sdk/widget");
const Dialog_1 = require("../../structure/Dialog");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const PayDockContext_1 = require("../../../../contexts/PayDockContext");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const PendingContentBlock_1 = require("../../structure/PendingContentBlock");
const stringSanitizer_1 = require("../../../../helpers/stringSanitizer");
const css = (0, cssComposer_1.default)(styles, "payDockForm");
if (!env.paydockPublicKey) {
    console.warn("paydockPublicKey not set");
}
/**
 * Renders a PayDock friendly form. PayDock accesses components based on their
 * selectors and highjacks the submit button.
 */
class _PayDockCreditCardForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ready: false
        };
        this.onSubmit = this.onSubmit.bind(this);
    }
    onSubmit() {
        // please note - submitting does not trigger a validate
        if (this.validationErrors && this.validationErrors.length) {
            return Promise.reject();
        }
        // trigger manual submit
        this.widget.trigger("submit_form");
        // spin button until form resolves
        return new Promise((resolve, reject) => {
            this.submitResolve = resolve;
            this.submitReject = reject;
        }).catch(e => {
            console.error("PayDoc error", e);
            this.submitResolve = null;
            this.submitReject = null;
            return Promise.reject();
        });
    }
    componentDidMount() {
        const { onSuccess, prefillData = {}, gatewayId } = this.props;
        if (!gatewayId)
            return;
        this.widget = new widget_1.HtmlWidget("#payDockWidget", env.paydockPublicKey, gatewayId);
        if (env.paydockEnv) {
            this.widget.setEnv(env.paydockEnv);
        }
        const reject = () => {
            if (this.submitReject) {
                this.submitReject();
                this.submitResolve = null;
                this.submitReject = null;
            }
        };
        const resolve = () => {
            if (this.submitReject) {
                this.submitResolve();
                this.submitResolve = null;
                this.submitReject = null;
            }
        };
        this.widget.setSupportedCardIcons(["mastercard", "visa"]);
        this.widget.setFormFields(["email"]);
        this.widget.setHiddenElements(["submit_button"]);
        // this.widget.setRefId("custom-ref-id");
        // widget.interceptSubmitForm("#paydockForm");
        // widget.onFinishInsert(
        //   'input[name="payment_source_token"]',
        //   "payment_source"
        // );
        this.widget.setStyles({
            background_color: "#fff",
            border_color: "#9b9b9b",
            text_color: "#242021",
            button_color: "#64bcae",
            font_size: "16px"
        });
        this.widget.setElementStyle("input", null, {
            border: "#9b9b9b solid 1px",
            height: "40px"
        });
        this.widget.on("metaChange", (data) => {
            // data.card_number_length
            // data.type,
            this.card = {
                cardType: data.card_scheme,
                cardNumberLast4: data.card_number_last4
                // paymentToken:
                // nameOnCard:
                // expirationDate:
            };
        });
        this.widget.on("validation", (data) => {
            // console.log("validate", data);
            this.validationErrors = data.invalid_fields;
            reject();
        });
        this.widget.on("validationError", (data) => {
            // console.log("validationError", data);
            reject();
        });
        this.widget.on("checkoutError", (data) => {
            // console.log("checkoutError", data);
            reject();
        });
        this.widget.on("systemError", (data) => {
            // console.log("systemError", data);
            reject();
        });
        this.widget.on("finish", (data) => {
            // console.log("finish", data);
            this.card.paymentToken = data.payment_source;
            resolve();
            onSuccess(this.card);
        });
        this.widget.on("afterLoad", (data) => {
            this.setState({ ready: true });
        });
        if (prefillData) {
            this.widget.setFormValues({
                email: prefillData.email || "",
                // BR-844 Paydock doesn't allow "-" or apostrophes for card name
                card_name: (0, stringSanitizer_1.removeDashes)((0, stringSanitizer_1.removeApostrophes)(prefillData.nameOnCard)) || ""
            });
        }
        this.widget.load();
    }
    render() {
        const { ready } = this.state;
        const { gatewayId, disclaimer, onSkip } = this.props;
        return (React.createElement("div", { id: "payDockForm", className: css("", { "-loading": !ready }) },
            gatewayId ? (React.createElement(React.Fragment, null,
                !!disclaimer && React.createElement("p", { className: css("disclaimer") }, disclaimer),
                React.createElement(PendingContentBlock_1.PendingContentBlock, { size: "payDock", check: ready, message: "Loading credit card form..." }),
                React.createElement("div", { id: "payDockWidget" }))) : (React.createElement(React.Fragment, null, "Unable to load payment form")),
            React.createElement(Dialog_1.DialogFooter, { onAccept: ready && this.onSubmit, acceptLabel: "Add credit card", onCancel: ready && onSkip, cancelLabel: "Skip" })));
    }
}
const PayDockCreditCardForm = props => {
    const { gatewayId, prefillData } = (0, useRequiredContext_1.useRequiredContext)(PayDockContext_1.PayDockContext);
    // if no gateway id don't render the form. Without this, the form will try and render without
    // gateway id and spin forever, as it will not try and reload the widget on props update
    if (!gatewayId)
        return null;
    return (React.createElement(_PayDockCreditCardForm, Object.assign({ gatewayId: gatewayId, prefillData: prefillData }, props)));
};
exports.PayDockCreditCardForm = PayDockCreditCardForm;
//# sourceMappingURL=index.js.map